
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("kGVhZ", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $c537bf1421fc5200$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Chinese (Traditional)
var $c537bf1421fc5200$export$2e2bcd8739ae039 = {
    'ai-floating-context-menu.ai-dynamic-surface.rovo-panel-title': 'Rovo',
    'ai-smart-button.ai-actions.actions.section.text': "\u52D5\u4F5C",
    'ai-smart-button.ai-actions.give-feedback-action.title': "\u63D0\u4F9B\u610F\u898B\u53CD\u61C9",
    'ai-smart-button.ai-actions.help.section.text': "\u8AAA\u660E",
    'ai-smart-button.ai-actions.input.link-picker-button-label': "\u9023\u7D50",
    'ai-smart-button.ai-actions.input.mention-button-label': "\u63D0\u53CA",
    'ai-smart-button.ai-actions.input.placeholder': "\u8F38\u5165\u60A8\u7684\u9700\u8981",
    'ai-smart-button.ai-actions.input.send-button-label': "\u50B3\u9001",
    'ai-smart-button.ai-actions.item.betaLozenge': "\u6E2C\u8A66\u7248",
    'ai-smart-button.ai-actions.item.newLozenge': "\u65B0",
    'ai-smart-button.ai-actions.rovo-agents.add-icon-label': "\u65B0\u589E\u5716\u793A",
    'ai-smart-button.ai-actions.rovo-agents.automation-icon-label': "\u81EA\u52D5\u5316\u5716\u793A",
    'ai-smart-button.ai-actions.rovo-agents.automations.text': "\u81EA\u52D5\u5316",
    'ai-smart-button.ai-actions.rovo-agents.create-agent.text': "\u700F\u89BD\u5BA2\u670D\u4EBA\u54E1",
    'ai-smart-button.ai-actions.rovo-agents.create-automation.text': "\u5EFA\u7ACB\u81EA\u52D5\u5316",
    'ai-smart-button.ai-actions.rovo-agents.section.text': "\u5DE5\u4F5C\u5BA4",
    'ai-smart-button.ai-dynamic-surface.components.greeting.intro-second-line': "\u6211\u53EF\u4EE5\u5982\u4F55\u63D0\u4F9B\u5354\u52A9\uFF1F",
    'ai-smart-button.ai-dynamic-surface.components.greeting.intro-text-headline': "{name}\uFF0C\u60A8\u597D\uFF1A",
    'ai-smart-button.ai-proactive-nudge.dismiss': "\u95DC\u9589",
    'ai-smart-button.feedback-action.ask-question-option': "\u63D0\u51FA\u554F\u984C",
    'ai-smart-button.feedback-action.cancel-button-label': "\u53D6\u6D88",
    'ai-smart-button.feedback-action.choose-feedback-option': "\u9078\u64C7\u4E00\u500B",
    'ai-smart-button.feedback-action.feedback-entry-bug-heading': "\u63CF\u8FF0\u932F\u8AA4\u6216\u554F\u984C",
    'ai-smart-button.feedback-action.feedback-entry-comment-heading': "\u8B93\u6211\u5011\u77E5\u9053\u60A8\u7684\u60F3\u6CD5",
    'ai-smart-button.feedback-action.feedback-entry-question-heading': "\u60A8\u60F3\u8981\u77E5\u9053\u4EC0\u9EBC\uFF1F",
    'ai-smart-button.feedback-action.feedback-entry-suggest-heading': "\u8B93\u6211\u5011\u77E5\u9053\u60A8\u5E0C\u671B\u6539\u5584\u7684\u9805\u76EE",
    'ai-smart-button.feedback-action.leave-comment-option': "\u7559\u4E0B\u7559\u8A00",
    'ai-smart-button.feedback-action.report-bug-option': "\u56DE\u5831\u932F\u8AA4",
    'ai-smart-button.feedback-action.research-participation-message': "\u6211\u60F3\u8981\u53C3\u8207\u7522\u54C1\u7814\u7A76",
    'ai-smart-button.feedback-action.select-feedback-heading': "\u9078\u53D6\u610F\u898B\u53CD\u61C9",
    'ai-smart-button.feedback-action.submit-button-label': "\u50B3\u9001\u610F\u898B\u53CD\u61C9",
    'ai-smart-button.feedback-action.suggest-improvement-option': "\u5EFA\u8B70\u6539\u9032",
    'ai-smart-button.feedback-action.title': "\u63D0\u4F9B\u610F\u898B\u53CD\u61C9",
    'ai-smart-button.feedback-item.icon-label': "\u610F\u898B\u53CD\u61C9\u5716\u793A",
    'ai-smart-button.reference.close-button-label': "\u95DC\u9589",
    'quick-summary.feedback.summary.placeholder': "Atlassian Intelligence \u6709\u54EA\u4E9B\u65B9\u9762\u8868\u73FE\u826F\u597D\uFF1F\u6709\u4EC0\u9EBC\u53EF\u4EE5\u6539\u5584\u7684\u55CE\uFF1F",
    'quick-summary.feedback.title': "\u5354\u52A9\u6211\u5011\u6539\u5584 Atlassian Intelligence"
};

});


//# sourceMappingURL=zh_TW.d4c31a5f.js.map
